import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {fetchAllOrderLogs,updateDefaultRows} from '../../../redux/actions/logs_adminActions';
import RowEdit from './RowEdit';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import {
  Divider as MuiDivider,
  Grid,
  CircularProgress,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
} from '@mui/material';
import { spacing } from '@mui/system';
import TablePagination from "../../../components/pagination/TablePagination"

const Divider = styled(MuiDivider)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => ({
    el,
    index,
  }));
  stabilizedThis.sort((a, b) => {
    const order = comparator(a.el, b.el);
    if (order !== 0) return order;
    return a.index - b.index;
  });
  return stabilizedThis.map((element) => element.el);
}

const headCells = [
  { id: 'email', alignment: 'left', label: 'Email' },
  { id: 'last_activity', alignment: 'left', label: 'Last Activity' },
];

const EnhancedTableHead = (props) => {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {
        headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            style={{
              fontSize: 'small',
              paddingBottom: '15px',
              paddingRight: '0px',
              paddingLeft: '8px',
            }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))
        }
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <Toolbar>
      <ToolbarTitle>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h4" id="tableTitle">
            Logs
          </Typography>
        )}
      </ToolbarTitle>
      <Spacer />
    </Toolbar>
  );
};

function EnhancedTable({ rows, defaultRows, actionsLoading,page,setPage }) {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('minutes');
  const [selected, setSelected] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(parseInt(defaultRows));
  const dispatch = useDispatch();
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.idPrepTime);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    dispatch(updateDefaultRows(parseInt(event.target.value, 10)));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;


  return (
    <div>
      <Paper>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer sx={{ px: 3 }}>
          <Table
            aria-labelledby="tableTitle"
            size={'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .map((row, index) => {
                  const isItemSelected = isSelected(row.idAdminRole);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={`${row.idAdminRole}-${index}`}
                      selected={isItemSelected}
                    >
                      <RowEdit
                        row={row}
                        labelId={labelId}
                        actionsLoading={actionsLoading}
                      />
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

function Logs() {
  const [pageNo, setPageNo] = useState(1);
  const navigate = useNavigate();
  const { userState } = useSelector(
    (state) => ({ userState: state.auth }),
    shallowEqual,
  );
  const { currentState } = useSelector(
    (state) => ({ currentState: state.adminlogs }),
    shallowEqual,
  );
  const { entities, defaultRows, listLoading, actionsLoading } = currentState;

  const dispatch = useDispatch();

  useEffect(() => {
    if (userState.isAuthenticated && pageNo>0) {
      dispatch(fetchAllOrderLogs(defaultRows,pageNo));
    } else {
      navigate('/');
    }
  }, [dispatch, userState.isAuthenticated, navigate,defaultRows,pageNo]);


  useEffect(()=>{

  },[entities])

  const Changed=(difference)=>{
      setPageNo(pageNo+difference);
  }

  return (
    <React.Fragment>
      <Helmet title="Logs" />
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            {'Welcome back'},{' '}
            {userState && userState.user && userState.user.displayName
              ? userState.user.displayName
              : 'Admin'}
          </Typography>
          <Typography variant="subtitle1" display="inline" sx={{ ml: 4 }}>
            {moment().format('dddd, DD MMMM, YYYY')}
          </Typography>
        </Grid>
      </Grid>

      <Divider my={6} sx={{ pb: 2 }} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          {listLoading ? (
            <Grid container direction="row" justifyContent="center">
              <CircularProgress sx={{ color: 'white' }} />
            </Grid>
          ) : (
            <EnhancedTable
              rows={entities === null ? [] : entities}
              defaultRows={currentState.defaultRows}
              actionsLoading={actionsLoading}
              page={pageNo}
              setPage={Changed}
            />
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Logs;
